// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.sdk.commons.api.dto.AbSemanticVersionNumber
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class AbSemanticVersionNumber {
  static createAbSemanticVersionNumber(major, minor, patch) {
    const retVal = new AbSemanticVersionNumber();
    retVal.initAbSemanticVersionNumber(major, minor, patch);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createAbSemanticVersionNumber factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cascad.AbSemanticVersionNumber";
  }
  initFromJson(json, deserializeContext) {
    this.initAbSemanticVersionNumber(json.major != null ? json.major : null, json.minor != null ? json.minor : null, json.patch != null ? json.patch : null);
  }
  initAbSemanticVersionNumber(major, minor, patch) {
    this._major = major;
    this._minor = minor;
    this._patch = patch;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["major"] = this._major;
    retVal["minor"] = this._minor;
    retVal["patch"] = this._patch;
    return retVal;
  }
  get major() {
    return this._major;
  }
  set major(value) {
    this._major = value;
  }
  get minor() {
    return this._minor;
  }
  set minor(value) {
    this._minor = value;
  }
  get patch() {
    return this._patch;
  }
  set patch(value) {
    this._patch = value;
  }
}
//# sourceMappingURL=AbSemanticVersionNumber.js.map
